const CHALLENGE_TYPES = {
  miles: 'miles',
  steps: 'steps',
  minutes: 'minutes',
  checkins: 'check-ins',
  leastMinutes: 'least-minutes',
  hydration: 'ounces-of-water',
};

const CHALLENGE_DISPLAY = {
  miles: 'Miles',
  steps: 'Steps',
  minutes: 'Minutes',
  'check-ins': 'Events',
  'ounces-of-water': 'oz',
};

export {CHALLENGE_DISPLAY, CHALLENGE_TYPES};
